import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { useIsHomePage } from "../../utils/location";
import Header from "../../components/magnolia/header/Header";
import Footer from "../../components/magnolia/footer/Footer";

// For all pages (Magnolia and Static) but Homepage, Footer area is rendered here and takes the content from the store
// Footer area is also conditionally rendered for Homepage in Standard page template to make it editable

const BaseLayout = ({ children }) => {
    const rootPage = useSelector((state) => state.rootPageData);
    const isHomePage = useIsHomePage();

    return (
        <Fragment>
            {rootPage.navigation && <Header navigationId={rootPage.navigation} />}
            {children}
            {!isHomePage && rootPage.footer && <Footer content={rootPage.footer} />}
        </Fragment>
    );
};

export default BaseLayout;
